module.exports = __webpack_public_path__ + "static/media/background-vidar-nordli-mathisen-unsplash.8827936a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-vidar-nordli-mathisen-unsplash.jpg
// module id = 1748
// module chunks = 0